import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { ValidatorForm } from 'react-material-ui-form-validator';
import SearchField from 'components/SearchField'; // Ensure the path is correct

/**
 * TableTopSearch component provides a search and total count display at the top of the table.
 * @param {object} props - The props for TableTopSearch.
 * @param {string} props.title - The title for which the total count is shown.
 * @param {number} props.rowCount - The total number of items to display.
 * @param {boolean} props.showTotalWithTitle - Determines whether to show the total count along with the title.
 * @param {function} props.onSearchChange - Callback function for handling changes in the search input.
 * @param {boolean} props.showSearch - Determines whether to display the search field.
 * @param {function} props.onSubmitSearch - Callback function for handling search form submissions.
 */
const TableTopSearch = ({ title, rowCount, showTotalWithTitle, onSearchChange, showSearch, onSubmitSearch }) => {
  return (
    <div className='w-full justify-end flex mb-2'>
      <div className='w-full'>
        <div className='w-full justify-end flex mb-2'>
          {showTotalWithTitle &&
            <p style={{ fontSize: 16, fontWeight: 600 }}>
              Total {title}: {rowCount}
            </p>
          }
        </div>
        {showSearch && (
          <ValidatorForm className='w-full' onSubmit={onSubmitSearch} instantValidate={false} autoComplete="off">
            <Grid container className='w-full justify-end flex'>
              <Grid item size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
                <SearchField
                  placeholder="Search..."
                  variant="outlined"
                  onChange={onSearchChange} // Capture change event
                />
              </Grid>
            </Grid>
          </ValidatorForm>
        )}
      </div>
    </div>
  );
};

TableTopSearch.propTypes = {
  title: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  showTotalWithTitle: PropTypes.bool,
  onSearchChange: PropTypes.func.isRequired,
  showSearch: PropTypes.bool,
  onSubmitSearch: PropTypes.func,
};

export default TableTopSearch;